import React from 'react';
import Pinwheel from './Pinwheel';

export default function PayrollContainer(props) {
  return (
    <Pinwheel
      clientId={props.location.state.scoringRequest.clientId}
      requestId={props.location.state.scoringRequest.requestId}
      onCompleted={() => props.onNextStep(props.history, props.location.state)}
      createScoringRequest={props.createScoringRequest}
    />
  );
}
